// Vendors that support ZIP-based (location) search.
export const LOCATION_SEARCH_SUPPORTED = ['kroger', 'bestbuy', 'target'];

export interface AmazonRegion {
  displayName: string;
  queryName: string;
  site: string;
}

export const AMAZON_REGIONS: AmazonRegion[] = [
  { displayName: 'United States', queryName: 'us', site: 'amazon.com' },
  { displayName: 'Belgium', queryName: 'be', site: 'amazon.be' },
  { displayName: 'Canada', queryName: 'ca', site: 'amazon.ca' },
  { displayName: 'France', queryName: 'fr', site: 'amazon.fr' },
  { displayName: 'Germany', queryName: 'de', site: 'amazon.de' },
  { displayName: 'Italy', queryName: 'it', site: 'amazon.it' },
  { displayName: 'Netherlands', queryName: 'nl', site: 'amazon.nl' },
  { displayName: 'Japan', queryName: 'jp', site: 'amazon.co.jp' },
  { displayName: 'Poland', queryName: 'pl', site: 'amazon.pl' },
  { displayName: 'Spain', queryName: 'es', site: 'amazon.es' },
  { displayName: 'Sweden', queryName: 'se', site: 'amazon.se' },
  { displayName: 'United Kingdom', queryName: 'uk', site: 'amazon.co.uk' },
];

export const VENDOR_DOWNLOAD_LINKS: Record<string, string> = {
  chrome:
    'https://chrome.google.com/webstore/detail/share-a-cart/hcjohblbkdgcoikaedjndgbcgcfoojmj',
  firefox:
    'https://addons.mozilla.org/en-US/firefox/addon/share-a-cart-for-everything/',
  edge: 'https://microsoftedge.microsoft.com/addons/detail/bgangcfogcfpakhljddkcjaaganbndeh',
  safari:
    'https://apps.apple.com/us/app/share-a-cart-for-everything/id1537641390',
  ios: 'https://apps.apple.com/us/app/share-a-cart/id1537641390',
  android: 'https://play.google.com/store/apps/details?id=com.ucs.sac',
};

export function detectBrowserKey(): keyof typeof VENDOR_DOWNLOAD_LINKS {
  const ua = navigator.userAgent.toLowerCase();
  if (/edg\//.test(ua)) return 'edge';
  if (/firefox|fxios/.test(ua)) return 'firefox';
  if (/android/.test(ua)) return 'android';
  if (/iphone|ipad|ipod/.test(ua)) return 'ios';
  if (/safari/.test(ua) && !/chrome|chromium|crios/.test(ua)) return 'safari';
  return 'chrome';
}

export const vendorFaviconUrl = (vendorId: string) =>
  `https://assets.share-a-cart.com/images/favis/32/${vendorId}.png`;
